import { PlusLockIcon } from './PlusLockIcon';

/**
 * author: Contributors
 * id 04ACEC00-DCEE-4FC8-9608-A2875F7A92A1
 * name plus-lock
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-lock.svg
 * tags
 * - Lock 
 */
export const PlusSecureIcon = PlusLockIcon;
export default PlusSecureIcon